import GuestType, { GuestTypes, GuestTypesEnum } from '@/types/taxcard/GuestType';
import Salutation from '@/types/taxcard/Salutation';
import moment, { Moment } from 'moment';
import { ValidationError, Validator } from 'class-validator';
import AdditionalMandatoryField from '@/types/validation/AdditionalMandatoryField';
import i18next from 'i18next';
import AccommodationProjection from '@/types/projections/AccommodationProjection';
import AdditionalGuestTypeFields from './AdditionalGuestTypeFields';
import BIObjectData from './BIObjectData';

//Booking Item Object, since we have different types of cards now being offered by the system we change this from taxcard to a generic object
export default class BIObject {
  public bIObjectData: BIObjectData = new BIObjectData();
  public additionalGuestTypeFields: AdditionalGuestTypeFields = new AdditionalGuestTypeFields();

  public constructor(
    bIObjectData?: BIObjectData | null,
    additionalGuestTypeFields?: AdditionalGuestTypeFields | null
  ) {
    this.bIObjectData = bIObjectData || new BIObjectData();
    this.additionalGuestTypeFields = additionalGuestTypeFields || new AdditionalGuestTypeFields();
  }

  public dehydrate(): string {
    return JSON.stringify(this);
  }

  public static hydrate(jsonObject: any): BIObject | null {
    // const data = JSON.parse(json);
    // const { bIObjectData, additionalGuestTypeFields } = data;
    if (!jsonObject) {
      return null;
    }
    return new BIObject(BIObjectData.hydrate(jsonObject.bIObjectData), AdditionalGuestTypeFields.hydrate(jsonObject.additionalGuestTypeFields))
    // return new BIObject(
    //   data.guestType,
    //   data.subGuestType,
    //   data.isAnonymous,
    //   data.salutation,
    //   data.title,
    //   data.firstName,
    //   data.lastName,
    //   data.birthday ? moment.utc(data.birthday) : undefined,
    //   data.addressStreetAndNumber,
    //   data.addressZipCode,
    //   data.addressCity,
    //   data.addressCountry,
    //   data.nationality,
    //   data.cellphoneNumber,
    //   data.email,
    //   data.petCount ? parseInt(data.petCount, 10) : 0,
    //   data.personCount ? parseInt(data.personCount, 10) : 0,
    //   data.stayBegin ? moment.utc(data.stayBegin) : undefined,
    //   data.stayEnd ? moment.utc(data.stayEnd) : undefined,
    //   data.isAnnual,
    //   data.annualCardKey,
    //   data.annualCardResidenceType,
    //   data.annualCardPhoto,
    //   data.savePersonData,
    //   data.option,
    //   data.groupOption,
    //   data.accommodation,
    //   data.accommodationsProvidersBookingNo,
    //   data.childCount,
    //   data.donationValue,
    //   data.additionalGuestTypeFields,
    // );
  }
}
